
import Vue from "vue";
import dayjs from "dayjs";

export default Vue.extend({
  name: "DatePicker",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "DD/MM/YYYY",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    displayValue(): string {
      if (!this.value) return "";
      const parsed = dayjs(this.value);
      return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "";
    },
    pickerValue(): string | null {
      if (!this.value) return null;
      const parsed = dayjs(this.value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
    },
  },

  methods: {
    openMenu(on: Record<string, (event: MouseEvent) => void>, event: MouseEvent) {
      on.click(event);
      this.$nextTick(() => {
        const input = (this.$refs.wrapper as HTMLElement)?.querySelector("input");
        input?.focus();
      });
    },
    onDateSelected(date: string) {
      this.$emit("input", date);
      this.$emit("change", date);
      this.menu = false;
    },
    onClear() {
      this.$emit("input", "");
      this.$emit("change", "");
    },
  },
});
